import React from "react";
import Navbar from "../components/Navbar";

const MainLayout = ({ children }) => {
  return (
    <div>
      <Navbar />
      <main className="p-1">{children}</main>
    </div>
  );
};

export default MainLayout;
